import {inject, Injectable} from '@angular/core';
import {AuthControllerService, RoleResponse} from "../../api";
import {Router} from "@angular/router";
import {StateConfigService} from "../state/state-config.service";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private authControllerService = inject(AuthControllerService);
  private stateService = inject(StateConfigService);
  private router = inject(Router);


   public hasProjectPrivilege(role: RoleResponse.PrivilegesEnum, projectId?: number): boolean {
     if (!projectId) {
       return this.stateService.projects.get(this.stateService.getProjectId())?.privileges?.includes(role) ?? false
     }

     return this.stateService.projects.get(projectId)?.privileges?.includes(role) ?? false;
   }

  public hasOrganisationPrivilege(role: RoleResponse.PrivilegesEnum, organisationId?: number): boolean {
    if (!organisationId) {
      return this.stateService.organisations.get(this.stateService.getOrganisationId())?.privileges?.includes(role) ?? false
    }

    return this.stateService.organisations.get(organisationId)?.privileges?.includes(role) ?? false;
  }

  /**
   * Plattform-globales Privileg (nicht projekt-/org-gebunden), z.B. GLOBAL_CHECKRULE_ADMIN.
   * Vergabe erfolgt ausschließlich per manuellem DB-Eintrag.
   */
  public hasGlobalPrivilege(role: RoleResponse.PrivilegesEnum): boolean {
    return this.stateService.globalPrivileges?.includes(role) ?? false;
  }
}
